// FAQ 路由与 SEO 配置
let data = [
  {
    router: "centro-de-ayuda",
    title: "FAQ: Domande frequenti",
    tagDescription: "Consulta il centro assistenza Rakumart per domande su pagamenti, ordini, spedizioni e servizi.",
  },
  "inizia-con-rakumart",
  "area-personale-utente",
  "come-ordinare",
  "metodi-di-pagamento",
  "logistica-y-envio",
  "garanzie-assistenza-post-vendita",
  {
    router: "che-cose-rakumart",
    title: "Che cos’è Rakumart? Guida completa alla piattaforma",
    tagDescription: "Scopri cos’è Rakumart, come funziona il servizio di approvvigionamento dalla Cina e perché è la soluzione ideale per il tuo business di e-commerce.",
  },
  {
    router: "cosa-fa-rakumart",
    title: "Cosa fa Rakumart? Funzionalità e vantaggi per il tuo business",
    tagDescription: "Vuoi sapere cosa fa Rakumart? Esplora le funzionalità della nostra piattaforma di importazione dalla Cina, dalla ricerca prodotti alla gestione della logistica.",
  },
  {
    router: "come-funziona-rakumart",
    title: "Come funziona Rakumart? Guida passo dopo passo all'importazione",
    tagDescription: "Scopri come funziona Rakumart: dalla ricerca dei fornitori al controllo qualità, fino alla spedizione in Italia. Segui la nostra guida per iniziare a importare.",
  },
  {
    router: "vantaggi-rakumart",
    title: "Vantaggi di Rakumart: perché scegliere la nostra piattaforma di sourcing",
    tagDescription: "Scopri i principali vantaggi di Rakumart: prezzi competitivi, controllo qualità, logistica semplificata e un supporto dedicato per il tuo business.",
  },
  {
    router: "servizi-aggiuntivi-prodotto",
    title: "Servizi aggiuntivi del prodotto: personalizzazione e controllo qualità",
    tagDescription: "Scopri tutti i servizi aggiuntivi offerti da Rakumart per i tuoi prodotti, tra cui controllo qualità, packaging personalizzato e ispezione delle merci.",
  },
  {
    router: "servizi-personalizzazione-oem-odm",
    title: "Servizi OEM/ODM e Personalizzazione Brand | Rakumart",
    tagDescription: "Valorizza il tuo business con i nostri servizi di personalizzazione OEM/ODM, etichettatura privata e packaging brandizzato su misura per i tuoi prodotti.",
  },
  {
    router: "a-chi-sono-rivolti-i-nostri-servizi",
    title: "A chi si rivolgono i servizi di Rakumart: soluzioni per ogni business",
    tagDescription: "Scopri se i servizi di Rakumart sono adatti alla tua attività: supportiamo e-commerce, piccole imprese, rivenditori e startup nel sourcing dalla Cina.",
  },
  {
    router: "come-registrarsi",
    title: "Come registrarsi e iniziare a usare Rakumart | Guida rapida",
    tagDescription: "Segui i semplici passaggi per registrarti su Rakumart e iniziare subito a importare prodotti dalla Cina in modo facile, sicuro e veloce.",
  },
  {
    router: "problemi-accesso-account",
    title: "Non riesci ad accedere al tuo account? Risoluzione problemi | Rakumart",
    tagDescription: "Hai difficoltà ad accedere al tuo profilo? Scopri come risolvere i problemi comuni di login, recuperare la password e contattare il supporto.",
  },
  {
    router: "modifica-dettagli-account",
    title: "Come modificare i dati del tuo account | Guida passo dopo passo",
    tagDescription: "Hai bisogno di aggiornare le tue informazioni personali? Segui questa guida per modificare rapidamente i dettagli del tuo account Rakumart in pochi clic.",
  },
  {
    router: "modifica-reimposta-password",
    title: "Modifica o reimposta la password del tuo account | Guida rapida",
    tagDescription: "Non ricordi la password o vuoi cambiarla per sicurezza? Segui i passaggi per reimpostare la tua password Rakumart in modo semplice e sicuro.",
  },
  {
    router: "dove-scaricare-fatture",
    title: "Come scaricare le fatture dei tuoi ordini | Guida Rakumart",
    tagDescription: "Scopri dove trovare e scaricare le tue fatture in formato PDF direttamente dal tuo pannello utente Rakumart. Segui i passaggi semplici e veloci.",
  },
  {
    router: "modifica-dati-fatturazione",
    title: "Come posso modificare i dati dell'importatore? | Guida Rakumart",
    tagDescription: "Vuoi modificare i dati dell'importatore nel tuo account? Segui questa guida passo dopo passo per aggiornare correttamente le informazioni dell'importatore su Rakumart.",
  },
  {
    router: "aggiungi-modifica-indirizzo-spedizione",
    title: "Come gestire il tuo indirizzo di spedizione | Guida Rakumart",
    tagDescription: "Hai bisogno di cambiare il luogo di consegna? Scopri come aggiungere, modificare o rimuovere facilmente i tuoi indirizzi di spedizione dal pannello utente.",
  },
  {
    router: "dove-trovare-coupon",
    title: "Dove posso trovare i coupon che ho ricevuto? | Guida Rakumart",
    tagDescription: "Non sai dove sono finiti i tuoi buoni sconto? Scopri come accedere alla sezione dedicata ai coupon nel tuo account e utilizzarli per i tuoi ordini.",
  },
  {
    router: "come-utilizzare-coupon-ordine",
    title: "Come posso utilizzare i coupon in un ordine? | Guida passo dopo passo",
    tagDescription: "Vuoi risparmiare sul tuo acquisto? Segui questa guida per scoprire come inserire e applicare correttamente il tuo codice sconto durante la procedura di checkout.",
  },
  {
    router: "necessario-account-per-ordine",
    title: "Devo creare un account per ordinare? | Guida Rakumart",
    tagDescription: "Ti chiedi se puoi completare un ordine come ospite? Scopri i vantaggi di avere un account registrato e come procedere con il tuo acquisto.",
  },
  {
    router: "come-effettuare-un-ordine",
    title: "Guida rapida: come effettuare un ordine su Rakumart",
    tagDescription: "Segui i semplici passaggi per completare il tuo acquisto online in modo facile e veloce. Scopri come aggiungere articoli al carrello e finalizzare il pagamento.",
  },
  {
    router: "acquisto-campioni-prodotti",
    title: "Come acquistare campioni di prodotti | Guida all'ordine",
    tagDescription: "Vuoi testare la qualità dei prodotti prima di un grande ordine? Scopri come richiedere e acquistare facilmente dei campioni sul nostro sito.",
  },
  {
    router: "tempi-ricezione-preventivo",
    title: "Tempi di ricezione del preventivo | Assistenza Clienti",
    tagDescription: "Hai richiesto un preventivo e attendi una risposta? Scopri i tempi medi di elaborazione e come monitorare lo stato della tua richiesta.",
  },
  {
    router: "consultare-stato-ordine",
    title: "Come monitorare lo stato del tuo ordine | Guida al tracciamento",
    tagDescription: "Vuoi sapere dove si trova il tuo pacco? Scopri come visualizzare facilmente lo stato del tuo ordine, dalla preparazione alla spedizione, direttamente dal tuo account.",
  },
  {
    router: "significato-ordine-attesa-preventivo",
    title: "Cosa significa ordine in attesa di preventivo? | Spiegazione stato ordine",
    tagDescription: "Hai visualizzato lo stato \"Ordine in attesa di preventivo\"? Spieghiamo cosa significa questa fase e quali sono i prossimi passi da seguire per completare il tuo acquisto.",
  },
  {
    router: "spedizione-internazionale-in-attesa-pagamento",
    title: "Spedizione internazionale in attesa di pagamento: significato e cosa fare",
    tagDescription: "Il tuo ordine mostra lo stato \"Spedizione internazionale in attesa di pagamento\"? Scopri cosa significa, perché compare questo avviso e come procedere con il saldo.",
  },
  {
    router: "quantita-minima-acquisto",
    title: "Quantità minima d'ordine: scopri se è prevista per i tuoi acquisti",
    tagDescription: "Ti stai chiedendo se esiste un limite minimo di pezzi per ordinare? Leggi la nostra guida per conoscere le politiche di acquisto e i requisiti minimi del nostro shop.",
  },
  {
    router: "modificare-ordine-effettuato",
    title: "Come modificare un ordine dopo l'acquisto | Guida rapida",
    tagDescription: "Hai già confermato l'ordine ma vuoi cambiare qualcosa? Scopri entro quali tempi e in che modo è possibile richiedere una modifica al tuo acquisto.",
  },
  {
    router: "mancata-ricezione-email-conferma-ordine",
    title: "Non hai ricevuto l'email di conferma ordine? Ecco cosa fare",
    tagDescription: "Non trovi l'email di conferma del tuo ordine? Controlla la cartella spam, verifica l'indirizzo inserito o contatta il nostro supporto per assistenza.",
  },
  {
    router: "significato-stati-packing-list",
    title: "Guida agli stati della packing list: significato e interpretazione",
    tagDescription: "Vuoi sapere a che punto è la tua spedizione? Scopri il significato di ogni stato della packing list e monitora facilmente il processo di preparazione del tuo ordine.",
  },
  {
    router: "aggiungere-articoli-ordine-confermato",
    title: "Aggiungere prodotti a un ordine confermato: è possibile?",
    tagDescription: "Hai dimenticato di aggiungere un prodotto? Scopri la nostra politica per integrare articoli a un ordine già concluso senza dover effettuare un nuovo acquisto.",
  },
  {
    router: "come-cancellare-ordine",
    title: "Come annullare un ordine: procedura e condizioni",
    tagDescription: "Hai cambiato idea? Scopri come richiedere l'annullamento del tuo ordine in pochi passaggi, in base allo stato attuale della tua spedizione.",
  },
  {
    router: "beni-proibiti-acquisto-trasporto",
    title: "Beni proibiti: elenco completo degli articoli non acquistabili e non trasportabili",
    tagDescription: "Scopri quali sono i beni proibiti che non possono essere acquistati o spediti. Consulta la lista completa per evitare blocchi doganali e problemi legali.",
  },
  {
    router: "metodi-pagamento-ordine",
    title: "Metodi di pagamento accettati: guida al pagamento del tuo ordine",
    tagDescription: "Scopri tutti i metodi di pagamento disponibili per finalizzare il tuo acquisto in sicurezza, tra carte di credito, PayPal e bonifici bancari.",
  },
  {
    router: "pagamento-spedizione",
    title: "Pagamento spedizione: metodi e istruzioni per il saldo",
    tagDescription: "Hai bisogno di pagare la spedizione del tuo pacco? Segui la nostra guida per conoscere i metodi di pagamento accettati e completare il saldo in tutta sicurezza.",
  },
  {
    router: "tariffe-acquisto-prodotti",
    title: "Tariffe e costi di acquisto: guida trasparente ai prezzi",
    tagDescription: "Vuoi conoscere le tariffe applicate per l’acquisto dei prodotti? Consulta la nostra guida dettagliata sui costi, commissioni e tasse applicate ai tuoi ordini.",
  },
  {
    router: "costi-aggiuntivi-alla-consegna",
    title: "Costi aggiuntivi alla consegna: cosa sapere su dazi e tasse",
    tagDescription: "Ti stai chiedendo se ci sono costi extra al momento della consegna? Scopri tutto quello che c'è da sapere su eventuali dazi doganali o commissioni aggiuntive.",
  },
  {
    router: "costo-controllo-qualita",
    title: "Controllo qualità: è un servizio a pagamento? Info e dettagli",
    tagDescription: "Vuoi sapere se il controllo di qualità è incluso nel prezzo o se comporta costi extra? Leggi le nostre FAQ per chiarire ogni dubbio sul servizio.",
  },
  {
    router: "che-tipo-di-pagamenti-si-accettano",
    title: "Metodi di pagamento accettati: guida alle opzioni disponibili",
    tagDescription: "Scopri tutti i metodi di pagamento accettati per i tuoi acquisti. Accettiamo carte di credito, bonifici e altre modalità sicure per garantirti la massima comodità.",
  },
  {
    router: "valute-accettate-pagamento",
    title: "Valute accettate: scopri con quali monete puoi pagare",
    tagDescription: "Hai dubbi su quali valute accettiamo? Scopri l'elenco completo delle monete disponibili per completare il tuo ordine in tutta semplicità.",
  },
  {
    router: "calcolo-peso-fatturabile-logistica",
    title: "Guida al calcolo del peso fatturabile: norme e criteri logistici",
    tagDescription: "Scopri come calcolare correttamente il peso fatturabile delle tue spedizioni. Comprendi la differenza tra peso reale e peso volumetrico per ottimizzare i tuoi costi logistici.",
  },
  {
    router: "costi-spedizione",
    title: "Costi di spedizione: tariffe e informazioni sulla consegna",
    tagDescription: "Scopri i dettagli sui nostri costi di spedizione. Consulta le tariffe in base alla destinazione e al peso per pianificare al meglio i tuoi acquisti.",
  },
  {
    router: "tempi-consegna-ordini",
    title: "Tempi di consegna: scopri quando arriverà il tuo ordine",
    tagDescription: "Hai ordinato un prodotto e vuoi sapere quando arriverà? Consulta qui i nostri tempi medi di consegna e le informazioni sulla tracciabilità del pacco",
  },
  {
    router: "tracciamento-ordine",
    title: "Tracciamento ordine: monitora la tua spedizione in tempo reale",
    tagDescription: "Inserisci il tuo numero d'ordine per sapere esattamente dove si trova il tuo pacco. Monitora lo stato della spedizione in tempo reale in modo semplice e veloce.",
  },
  {
    router: "quando-ricevero-numero-tracciamento",
    title: "Numero di tracciamento: quando viene inviato?",
    tagDescription: "Vuoi sapere quando riceverai il tracking della tua spedizione? Scopri le tempistiche di invio del numero di tracciamento dopo la conferma dell'ordine.",
  },
  {
    router: "spiegazione-costi-spedizione",
    title: "Spiegazione costi di spedizione: come vengono calcolate le tariffe",
    tagDescription: "Vuoi capire meglio come vengono calcolate le spese di spedizione? Scopri nel dettaglio le nostre tariffe, i supplementi e le opzioni di consegna disponibili.",
  },
  {
    router: "beni-proibiti-spedizione",
    title: "Beni proibiti e merci non trasportabili - Guida completa",
    tagDescription: "Consulta l'elenco dei beni proibiti che non possono essere acquistati o trasportati tramite i nostri servizi di spedizione per motivi di sicurezza o restrizioni legali.",
  },
  {
    router: "selezione-vettori-logistici-rakumart",
    title: "Selezione vettori logistici Rakumart: criteri e qualità del servizio",
    tagDescription: "Scopri i rigorosi criteri con cui Rakumart valuta e seleziona i partner logistici internazionali per garantire spedizioni rapide, sicure e affidabili.",
  },
  {
    router: "sdoganamento-merci-dogana",
    title: "Sdoganamento merci: come funziona la procedura doganale",
    tagDescription: "Hai dubbi sullo sdoganamento delle merci? Scopri come funziona la procedura doganale, i documenti necessari e come velocizzare le operazioni di importazione.",
  },
  {
    router: "dove-spediamo",
    title: "Aree di spedizione e copertura logistica internazionale",
    tagDescription: "Scopri l'elenco completo delle destinazioni internazionali in cui effettuiamo le spedizioni e i dettagli sulla nostra copertura logistica globale.",
  },
  {
    router: "mancata-ricezione-email-spedizione",
    title: "Ordine non tracciato? Risolvi i problemi con le email di spedizione",
    tagDescription: "Non hai ricevuto l'email di conferma spedizione? Controlla le cause comuni, come lo spam o errori nell'indirizzo, e scopri come verificare lo stato del tuo ordine.",
  },
  {
    router: "motivi-ritardo-ordine",
    title: "Ordine in ritardo: cause comuni e come monitorare la consegna",
    tagDescription: "Il tuo ordine sta tardando ad arrivare? Scopri le cause più comuni dei ritardi nelle spedizioni e come verificare lo stato attuale della tua consegna.",
  },
  {
    router: "problemi-tracking-spedizione",
    title: "Tracking non aggiornato? Ecco cosa significa e cosa fare",
    tagDescription: "Il tracciamento della tua spedizione è fermo? Scopri i motivi per cui il tracking potrebbe non mostrare aggiornamenti e dopo quanto tempo dovresti preoccuparti.",
  },
  {
    router: "differenze-metodi-spedizione",
    title: "Quale metodo di spedizione scegliere? Confronto opzioni di consegna",
    tagDescription: "Scopri le differenze tra i nostri tre metodi di spedizione disponibili: tempi di consegna, costi e caratteristiche per scegliere l'opzione più adatta alle tue esigenze.",
  },
  {
    router: "spedizione-diretta-magazzini-amazon",
    title: "Spedizione ordini verso magazzini Amazon: è possibile?",
    tagDescription: "Vuoi spedire un ordine direttamente a un centro logistico Amazon? Leggi le nostre linee guida per capire se questa opzione è consentita e come procedere correttamente.",
  },
  {
    router: "garanzie-offerte-da-rakumart",
    title: "Garanzie Rakumart: sicurezza e protezione per i tuoi acquisti",
    tagDescription: "Scopri le garanzie di protezione offerte da Rakumart per i tuoi acquisti. Proteggiamo la tua transazione e assicuriamo la qualità dei prodotti per una piattaforma affidabile.",
  },
  {
    router: "politica-campionatura-rakumart",
    title: "Politica campioni Rakumart: come richiedere e ricevere campioni",
    tagDescription: "Scopri come funziona la politica dei campioni su Rakumart. Scopri i passaggi per richiedere e testare la qualità dei prodotti prima di procedere con il tuo ordine all'ingrosso.",
  },
  {
    router: "controllo-qualita-merce-rakumart",
    title: "Servizio di controllo qualità merce Rakumart",
    tagDescription: "Scopri come Rakumart garantisce la qualità dei tuoi prodotti. Eseguiamo controlli accurati sulla merce prima della spedizione per offrirti la massima sicurezza.",
  },
  {
    router: "prodotti-non-superano-controllo-qualita",
    title: "Gestione prodotti non conformi: procedura controllo qualità Rakumart",
    tagDescription: "Hai dubbi su cosa accade in caso di esito negativo del controllo qualità? Scopri la procedura Rakumart per gestire i prodotti non conformi e proteggere il tuo ordine.",
  },
  {
    router: "come-verifichiamo-i-fornitori",
    title: "Verifica fornitori Rakumart: standard di selezione e controllo",
    tagDescription: "Scopri il rigoroso processo di selezione e verifica dei fornitori su Rakumart. Selezioniamo solo partner affidabili per garantire la qualità e la sicurezza dei tuoi acquisti.",
  },
  {
    router: "prodotti-certificazioni-ue-compliance",
    title: "Certificazioni e conformità CE dei prodotti | Rakumart",
    tagDescription: "Hai bisogno di prodotti certificati per il mercato UE? Scopri come verifichiamo la conformità alle normative europee e le certificazioni disponibili per i tuoi acquisti.",
  },
  {
    router: "procedura-gestione-articoli-difettosi",
    title: "Gestione articoli difettosi: politica di reso e assistenza | Rakumart",
    tagDescription: "Hai ricevuto un prodotto danneggiato o difettoso? Scopri i passaggi da seguire per richiedere assistenza, resi o rimborsi tramite il nostro servizio clienti.",
  },
  {
    router: "gestione-ordini-danneggiati-italia",
    title: "Ordine danneggiato alla consegna in Italia: assistenza e reclami",
    tagDescription: "Il tuo ordine è arrivato danneggiato in Italia? Scopri come segnalare il danno e avviare la procedura di rimborso o sostituzione in modo rapido e semplice.",
  },
  {
    router: "politica-reso-rimborso",
    title: "Politica di Reso e Rimborso | Guida Completa | Rakumart",
    tagDescription: "Consulta la nostra politica di reso e rimborso. Scopri i termini, le condizioni e le procedure per restituire un prodotto e ottenere un rimborso in modo semplice.",
  },
];

export default data;